import { EMPTY_OBJECT } from '../../constants/common'
import { postApi } from '../../utils/api'

import { REALTIME_CONNECT_TOKEN_API } from './Centrifuge.constants'

export function getRealtimeConnectToken({ outboundUuid } = EMPTY_OBJECT) {
  return postApi({
    endpoint: outboundUuid
      ? `idwell-api/api/v3/idwell-to-idwell/${outboundUuid}/realtime/connect/`
      : REALTIME_CONNECT_TOKEN_API,
  })
}
